<template>
  <div class="slider">
    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab" img-width="1024"
      img-height="600" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">

      <!-- <b-carousel-slide img-src="https://msobcfdc.in/downloads/image1.png"></b-carousel-slide> -->
      <b-carousel-slide img-src="https://res.cloudinary.com/dgrs2thvj/image/upload/v1704433651/rso12ld0lbuanugr8qxe.jpg"></b-carousel-slide>
      <!-- <b-carousel-slide img-src="https://msobcfdc.in/downloads/image3.png"></b-carousel-slide> -->
      <!-- <b-carousel-slide img-src="https://msobcfdc.in/downloads/image4.png"></b-carousel-slide> -->
      <!-- <b-carousel-slide img-src="https://msobcfdc.in/downloads/image5.png"></b-carousel-slide> -->
      <b-carousel-slide img-src="https://res.cloudinary.com/dgrs2thvj/image/upload/v1704433638/qap1fuvbuqvk9tyid4og.jpg"></b-carousel-slide>
      <b-carousel-slide img-src="https://res.cloudinary.com/dgrs2thvj/image/upload/v1704433562/pok4xki0lgfzv8uphtkl.jpg"></b-carousel-slide>

    </b-carousel>
   <div class="containerx">
    <marquee class="marq">
      <h4 style="font-size:44px; font-weight:600; padding-top:3px;color:#ac7601">इतर मागासवर्ग महामंडळाचा पुढाकार महिलांचा होणार आर्थिक उद्धार !
      </h4>
    </marquee>
   </div>

     


  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>
<style>
.slider{
  position: relative;
}

.containerx {
  width: 94%;
  left: 2%;
  position: absolute;
  bottom: 2%;
  background-color: #fff9;
  padding: 2%;
  text-align: center;
}
@media (min-width: 767px) and (max-width: 1444px) {
  .carousel-inner{
    height: 100vh;
  }
  img.img-fluid.w-100.d-block{
    height: 100vh;
  }
}

 
</style>


// WEBPACK FOOTER //
// src/components/Slider.vue